import dayjs from "dayjs";
import { CardContent, Typography } from "@mui/material";

import { EmEmoji } from "components/EmojiPicker/EmojiPicker";
import LinkifyContainer from "components/LinkifyContainer";
import CardWithAvatar from "components/CardWithAvatar";
import isSameDateTime from "utils/isSameDateTime";
import { EventRow } from "api/event";
import useBoundStore from "store";
import LocalStorage from "services/LocalStorage";
import styles from "./eventDetails.module.scss";

export interface EventDetailsProps {
  event: EventRow;
}

function EventDetails(props: EventDetailsProps) {
  const { event } = props;
  const startDate = dayjs(event.start_date);
  const endDate = dayjs(event.end_date);
  const externalLinkNavigation = useBoundStore((state) => state.generalSettings.externalLinkNavigation);
  const localStorage = LocalStorage.getInstance();
  const alreadySeenLinks = localStorage.getAllowedExternalLinks();
  let eventDate: string | undefined;
  if (isSameDateTime(event.start_date, event.end_date)) {
    eventDate = startDate.format("MMMM DD, HH:mm");
  } else {
    eventDate = `${startDate.format("MMMM DD, HH:mm")} - ${endDate.format("MMMM DD, HH:mm")}`;
  }

  /**
   * Handle confirm navigation
   *
   * @param clickedLink
   */
  function handleConfirmNavigation(clickedLink: string | null): void {
    if (clickedLink) {
      localStorage.setAllowedExternalLinks(clickedLink);
      window.open(clickedLink, "_blank")?.focus();
    }
  }

  return (
    <CardWithAvatar
      icon={<EmEmoji id={event.icon.id} size={24} skin={event.icon.skin} />}
      noHeaderGutterBottom
      title={event.name}
      subheader={eventDate}
    >
      <CardContent className={styles.cardContent}>
        <div className={styles.selectableArea}>
          <LinkifyContainer
            alreadySeenLinks={alreadySeenLinks}
            confirmNavigation={externalLinkNavigation}
            onConfirmNavigation={handleConfirmNavigation}
          >
            <Typography variant='body2' component='p' className={styles.description}>
              {event.details}
            </Typography>
          </LinkifyContainer>
        </div>
      </CardContent>
    </CardWithAvatar>
  );
}

export default EventDetails;
